<template>
  <section>
    <!-- ROUTER HEADER SHOULD GO HERE -->
    <div class="page-banner">
      <div class="container-fluid border-bottom">
        <div class="row align-items-center">
          <div class="col-md-7 p-4 pt-5">
            <h1>
              <img
                src="@/assets/img/_title/13-IP-interview-prep-for-people-with-disabilities.svg"
                class="img-fluid"
                alt="Interview prep for people with disabilities"
                srcset=""
              >
            </h1>
          </div>
          <div class="col-md-5">
          </div>
        </div>
      </div>
    </div>

    <!-- ROUTER CONTENT GOES HERE -->

    <!-- TEXT CONTENT -->
    <content-block class="bg-light-grey">
      <div class="row">
        <div class="col-md-7 p-4">
          <p>Interviews can be used as an opportunity for candidates to get to know an employer and determine whether or not they will be accommodating to student employees with special needs.</p>
          <p>It’s important to ask lots of questions to determine if they are an inclusive workplace. You might ask…</p>
          <ul>
            <li>What are your department’s core values?</li>
            <li>How important is diversity to this department?</li>
            <li>What is the workplace culture like?</li>
            <li>What policies and practices are in place to ensure an equitable and inclusive work environment?</li>
          </ul>
        </div>
        <div class="col-md bg-img bg-img--interview-prep-03-1">
          <!-- <img
            src="@/assets/img/_content/template-placeholder-01.jpg"
            alt=""
            class="img-fluid content-block__img"
          > -->
        </div>
      </div>
    </content-block>
    <content-block>
      <div class="row">
        <div class="col-md p-4">
          <p>While preparing for an interview, familiarize yourself with the types of questions that employers <strong>cannot</strong> ask, including:</p>
          <ul>
            <li>Do you have any disabilities or medical conditions?</li>
            <li>How did you become disabled?</li>
            <li>How often do you miss work for doctor’s appointments?</li>
            <li>How many sick days did you take at your last job?</li>
          </ul>
          <p>If you are asked any inappropriate questions, the <strong>4R Approach</strong> can help you handle the situation.</p>
          <div class="carousel">
            <hooper
              ref="carousel_01"
              class="mb-4"
            >
              <slide>
                <div class="slide">
                  <div>
                    <h3><strong>Repurpose</strong></h3>
                    <p>Answer the question that was asked without revealing more information than you wanted them to know. Use your response to focus on your strengths, skills and ability to perform the job.</p>
                  </div>
                </div>
              </slide>

              <slide>
                <div class="slide">
                  <div>
                    <h3><strong>Redirect</strong></h3>
                    <p>Redirect the question by understanding what the intention was and emphasizing aspects that speak to your strengths, skills and ability to perform the job.</p>
                  </div>
                </div>
              </slide>

              <slide>
                <div class="slide">
                  <div>
                    <h3><strong>Rephrase</strong></h3>
                    <p>Ask the interviewer to rephrase or clarify the question. This might prompt them to consider the appropriateness of what they’re asking.</p>
                  </div>
                </div>
              </slide>

              <slide>
                <div class="slide">
                  <div>
                    <h3><strong>Refuse</strong></h3>
                    <p>Do not answer the question and communicate your preference not to answer the question or ask the interviewer about the relevance of the question to the job. In the event that a series of questions are inappropriate, you may choose to end the interview altogether.</p>
                  </div>
                </div>
              </slide>
              <hooper-navigation slot="hooper-addons">
                <img
                  slot="hooper-prev"
                  src="@/assets/img/_ui/svg/carousel-back.svg"
                  alt="previous"
                  srcset=""
                >
                <img
                  slot="hooper-next"
                  src="@/assets/img/_ui/svg/carousel-next.svg"
                  alt="next"
                  srcset=""
                >
              </hooper-navigation>

              <hooper-pagination slot="hooper-addons"></hooper-pagination>
            </hooper>
          </div>
        </div>
        <!-- <div class="col-md bg-img bg-img--test-01">
          <img
            src="@/assets/img/_content/template-placeholder-01.jpg"
            alt=""
            class="img-fluid content-block__img"
          >
        </div> -->
      </div>
    </content-block>
    <content-block class="bg-light-grey">
      <div class="row">
        <div class="col-md bg-img bg-img--interview-prep-03-2">
          <!-- <img
            src="@/assets/img/_content/template-placeholder-01.jpg"
            alt=""
            class="img-fluid content-block__img"
          > -->
        </div>
        <div class="col-md-7 p-4">
          <h2 class="content-block__header">Disclosing a disability and requesting accommodations</h2>
          <p>A job interview can be a good opportunity to disclose your disability and request accommodation.</p>
          <p>Disclosing information like this is a very personal decision and can be a difficult process. You are <strong>not legally required</strong> to disclose that you have a disability.</p>
          <p>However, if a disability affects your ability to carry out the essential functions of a particular job, we recommend you disclose your needs and exercise the legal right to reasonable accommodations in the workplace.</p>
          <p>If you have any questions about disclosing a disability or asking for accommodations, please connect with an Employment Advisor in the <a href="https://hire.centennialcollege.ca/home.htm" target="_blank">Career Services department</a>.</p>
          <p><em>Adapted from Roadmap to Career Readiness: Supporting the Employment of Students with Disabilities – Faculty and staff toolkit by the Centre for Global Citizenship, Education and Inclusion</em></p>
        </div>
      </div>
    </content-block>
  </section>
</template>

<script>
import ContentBlock from '@/components/ContentBlock.vue'
// import Accordion from '@/components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination
} from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    ContentBlock,
    // SidebarMenu,
    // Accordion,
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
